import axios from 'axios';
import Cookies from 'js-cookie';
import buildApiRequestConfig from '../api/url-builder';
import routes from '../api/routes';

// The server answers 403 with action 'upgrade_required' / 'addon_required'
// when the company's plan doesn't cover something (subscription-guard-service.js).
// Every such response - from useApi or a direct axios call - fires this event,
// and components/plan-required-gate.tsx opens the upgrade / add-on prompt.
export const PLAN_REQUIRED_EVENT = 'fineants:plan-required';

// The page that made the request usually toasts its failure too - the
// toaster (providers/toaster-provider.tsx) skips error/warning toasts this
// soon after the prompt opened, so the prompt is all the user sees.
const TOAST_SUPPRESS_MS = 3000;
let promptOpenedAt = 0;

export const planPromptJustOpened = () => Date.now() - promptOpenedAt < TOAST_SUPPRESS_MS;

const isPlanRequired = (status?: number, data?: any) =>
    status === 403 && (data?.action === 'upgrade_required' || data?.action === 'addon_required');

// Opens the upgrade / add-on prompt for a plan feature the company doesn't
// have - for a read-only page's create/update/delete buttons (e.g. Documents
// without the add-on), before any form opens.
export const openPlanPrompt = async (entityId: number | string | undefined, feature: string) => {
    if (entityId == null) return;
    const { url, method } = buildApiRequestConfig(routes.subscription.featureGate, [
        { param: 'entityId', value: entityId },
        { param: 'feature', value: feature },
    ]);
    const token = Cookies.get('token');
    const { data } = await axios({ url, method, headers: token ? { Authorization: `Bearer ${token}` } : {} });
    if (data?.success && !data.allowed && data.action) {
        promptOpenedAt = Date.now();
        window.dispatchEvent(new CustomEvent(PLAN_REQUIRED_EVENT, { detail: data }));
    }
};

axios.interceptors.response.use(
    response => response,
    error => {
        const { status, data } = error?.response || {};
        if (isPlanRequired(status, data)) {
            promptOpenedAt = Date.now();
            window.dispatchEvent(new CustomEvent(PLAN_REQUIRED_EVENT, { detail: data }));
        }
        return Promise.reject(error);
    },
);
